import { ReactNode } from 'react';

import { Box } from '@mui/material';

const FormContainer = ({ children }: { children: ReactNode }) => (
  <Box
    sx={{
      width: '100%',
      display: 'grid',
      rowGap: 1,
      columnGap: 0.5,
      marginLeft: 'auto',
      boxSizing: 'border-box',
      marginRight: 'auto',
      justifyContent: 'center',
      gridTemplateColumns: 'repeat(1, 1fr)',
    }}
  >
    {children}
  </Box>
);

export default FormContainer;
